import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { RootState } from 'store/store';
import VehicleDetails from '../sub-component/VehicleDetails';
import { Grid } from '@mui/material';
import { DateCalendarInput } from 'sharedComponents/inputGroup/DateCalendar';
import { formRequiredRules } from 'helper';
import { errorMessage } from 'constants/CommonConstants';
import dayjs from 'dayjs';
import { InputRadio } from 'sharedComponents/inputGroup/InputRadio';
import { TIME_OPTIONS } from 'pages/digitalRetailing/DigitalRetailingConstant';

const Step1: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  const { t } = useTranslation();

  const today = dayjs();

  const hasCalledNextStep = React.useRef(false);

  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();
  const { authenticateClientData } = useSelector((state: RootState) => state.auth);

  const leadSourceId = authenticateClientData?.data?.widgetData?.leadSourceId;
  const zipCode = authenticateClientData.data?.widgetData?.zipCode;
  const dealershipName = authenticateClientData.data?.widgetData?.dealershipName;
  const { control, trigger, getValues } = useFormContext();

  const timeOptions = TIME_OPTIONS.map((time) => ({ label: time, value: time }));

  const nextStep = async () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { firstName, lastName, phone, email } = getValues();

    const updatedData = {
      firstName: firstName,
      lastName: lastName,
      phone: phone,
      email: email,
      leadSourceId: leadSourceId,
      country: 'CA',
      birthDate: '1991-01-01',
      zipCode: zipCode,
    };

    onNext?.();

    // dispatch(
    //   postTradeInLeadCreation({
    //     data: updatedData,
    //     leadTypeID: authenticateClientData?.data?.widgetData?.leadTypeId,
    //   })
    // ).then((res) => {
    //   if (Object.keys(res?.payload).length && res?.payload?.message) {
    //     onNext?.();
    //   }
    // });
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <>
      <p className="text-center">{t('bookTestDrive.title')}</p>
      <VehicleDetails />
      <hr className="mb-4" />
      <Grid container spacing={2} marginBottom={3} direction={'column'}>
        <Grid item lg={4} md={5} sm={12} xs={12}>
          <label className="input-label">{t('bookTestDrive.dateTime')}</label>
          <div className="bookappt-calendar">
            <DateCalendarInput
              name='calendar_appointmentDate'
              control={control}
              rules={formRequiredRules(errorMessage(t).required)}
              triggerValidationForField={trigger}
              minDate={today}
            />
          </div>
        </Grid>

        <Grid item lg={8} md={7} sm={12} xs={12}>
          <div className="bookappt-time">
            <InputRadio
              name={'calendar_time'}
              control={control}
              options={timeOptions}
              triggerValidationForField={trigger}
              rules={formRequiredRules(errorMessage(t).radioError)}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

const StepperForm1 = React.forwardRef(Step1);

export default StepperForm1;
